<template>
  <div class="pa-4">
    <div style="margin-bottom:20px">
      <div class="text-sm-right">
        <template v-for="(w) in availableWaivers">
          <v-btn 
            @click="swicthWaiverLang(w.lang)"
            :color="w.lang == selectedLang ? 'pink' : 'primary'"
            fab small dark :key="w.lang">
            {{w.lang}}
          </v-btn>
        </template>
      </div>
      <div class="text-sm-left">
        <span v-if="$i18n.locale=='es'">
          {{toNiceDateCustomFormat(today, 'DD/MM/YYYY')}}
        </span>
        <span v-else>
          {{toNiceDateCustomFormat(today, 'MM/DD/YYYY')}}
        </span>
      </div>
    </div>
    <div v-html="waiverContents" class="text-sm-left">
    </div>
    <div class="messages-area" v-html="messages">
    </div>
    <v-card>
      <v-card-title>
        <v-text-field
          style="margin-right:20px"
          :label="$t('message.participant_name')"
          v-model="participantName"
        ></v-text-field>
        <v-text-field
          :label="$t('message.email')"
          v-model="participantEmail"
        ></v-text-field>
      </v-card-title>
      <v-card-title style="width:600px">
        <v-text-field
          style="margin-right:20px"
          :label="$t('message.todays_date')"
          :placeholder="$t('message.date_placeholder')"
          v-model="date"
        ></v-text-field>
        <v-text-field
          :label="$t('message.initials')"
          v-model="initials"
        ></v-text-field>
      </v-card-title>
    </v-card>
    <v-switch
      :label="$t('message.agree_terms')"
      v-model="agree"
    >
    </v-switch>
    <v-btn
      color="secondary"
      @click="cancelWaiver()"
    >
      {{$t('message.cancel')}}
    </v-btn>
    <v-btn
      :disabled="agree ? false : true" 
      color="primary"
      @click="submitWaver()"
    >
      {{$t('message.accept')}}
    </v-btn>
  </div>
</template>

<script>
import Api from '@/services/Api';

export default {
  data() {
    return {
      waiverContents: this.$t('message.loading'),
      messages: null,
      agree: false,
      participantName: null,
      participantEmail: null,
      date: null,
      initials: null,
      today: new Date(),
      availableWaivers: null,
      selectedLang: null
    };
  },
  components: {
  },
  created() {
    console.log('Loading waver');
    Api().get('admins/academy/'+this.$store.state.selectedAcademy+'/waivers')
        .then(response => {
          this.loading = false;
          const data = response.data;
          if(data && data[0]){
            this.availableWaivers = data;
            this.selectedLang = data[0].lang;
            this.waiverContents = data[0].agreement;
          }
        });
  },
  watch: {
  },
  methods: {
    cancelWaiver(){
      window.history.length > 1 ? this.$router.go(-1) : this.navigateTo({name:'home'});
    },
    swicthWaiverLang(newLang){
      if(newLang != this.selectedLang){
        this.selectedLang = newLang;
        for(const w of this.availableWaivers){
          if(w.lang == newLang && w.agreement){
            this.waiverContents = w.agreement;
          }
        }
      }
    },
    submitWaver(){
      console.log('submitting waver');
      //Add succeess message and close one second after
      if(this.allowSubmit()){
        //Post data
        const postData = {
          name: this.participantName,
          email: this.participantEmail,
          date: this.date,
          initials: this.initials,
          lang: this.selectedLang
        };
        Api().post('admins/academy/'+this.$store.state.selectedAcademy+'/waiver' ,postData)
        .then(response => {
          const data = response.data;
          if(data){
            const vm = this;
            try{
              this.messages = '<span style="color:green;font-size:1.5em">'+this.$t('message.doc_submitted')+'</span>';
              setTimeout(function(){ 
                vm.cancelWaiver();
              }, 2000);
            }catch(e){
              console.log(e);
            }
          }
        })
        .catch(e => {
          if(e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        })
      }else{
        //Show Message
        this.messages = '<span style="color:red;font-size:1.5em">'+this.$t('message.fill_all_params')+'</span>';
      }
    },
    allowSubmit(){
      if(this.agree && this.participantName && this.date && this.initials){
        return true
      }
      return false;
    }
  }
};
</script>

<style scoped>
</style>
`